<script setup>
import { useNavigation } from '../../../Utils/useNavigation.js'

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  level: {
    type: Number,
    default: 0
  },
  textSize: {
    type: String,
    default: 'text-sm'
  },
  iconSize: {
    type: String,
    default: 'size-3'
  }
})

const { getHref } = useNavigation()
</script>

<template>
  <div
    class="px-4 py-1.5"
  >
    <a
      :href="getHref(item.href)"
      class="flex items-center whitespace-nowrap font-normal sm:font-medium sm:text-sm"
    >
      <Component
        v-if="item.hasIcon && item.iconComponent"
        :is="item.iconComponent"
        class="size-4 mr-1"
      />
      {{ item.name }}
    </a>
  </div>
</template>
